<template>
  <div class="row comment-moderation-list" id="comment-moderation-list" v-if="isShowComponent()">
    <div class="col">
      <div class="card mb-3">
        <div class="card-header align-items-center" v-if="params.hasTitle()">
          <div class="col">
            <h3 class="card-title">
              <span class="comment-select-all title">{{ params.getTitle() }}</span>
            </h3>
          </div>
        </div>
        <div class="card-header" v-if="countCategories() > 1">
          <ul class="nav nav-tabs card-header-tabs">
            <li class="nav-item" @click="comments.events.onCategory(categoryList.allCategory)" v-if="comments.isShowCategory(categoryList.allCategory)">
              <a class="nav-link" :class="{'active': comments.isActiveCategory(categoryList.allCategory)}">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon dropdown-item-icon icon-tabler icons-tabler-outline icon-tabler-list-letters"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M11 6h9" /><path d="M11 12h9" /><path d="M11 18h9" /><path d="M4 10v-4.5a1.5 1.5 0 0 1 3 0v4.5" /><path d="M4 8h3" /><path d="M4 20h1.5a1.5 1.5 0 0 0 0 -3h-1.5h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6z" /></svg>
                Все
              </a>
            </li>
            <li class="nav-item" @click="comments.events.onCategory(categoryList.newCategory)" v-if="comments.isShowCategory(categoryList.newCategory)">
              <a class="nav-link" :class="{'active': comments.isActiveCategory(categoryList.newCategory)}">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon dropdown-item-icon icon-tabler icons-tabler-outline icon-tabler-brand-telegram"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4" /></svg>
                Новые
              </a>
            </li>
            <li class="nav-item" @click="comments.events.onCategory(categoryList.approvedCategory)" v-if="comments.isShowCategory(categoryList.approvedCategory)">
              <a class="nav-link" :class="{'active': comments.isActiveCategory(categoryList.approvedCategory)}">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon dropdown-item-icon icon-tabler icons-tabler-outline icon-tabler-circle-check">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                  <path d="M9 12l2 2l4 -4" />
                </svg>
                Одобренные
              </a>
            </li>
            <li class="nav-item" @click="comments.events.onCategory(categoryList.rejectedCategory)" v-if="comments.isShowCategory(categoryList.rejectedCategory)">
              <a class="nav-link" :class="{'active': comments.isActiveCategory(categoryList.rejectedCategory)}">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon dropdown-item-icon icon-tabler icons-tabler-outline icon-tabler-circle-x"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M10 10l4 4m0 -4l-4 4" /></svg>
                Отклоненные
              </a>
            </li>
            <li class="nav-item" @click="comments.events.onCategory(categoryList.removedCategory)" v-if="comments.isShowCategory(categoryList.removedCategory)">
              <a class="nav-link" :class="{'active': comments.isActiveCategory(categoryList.removedCategory)}">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon dropdown-item-icon icon-tabler icons-tabler-outline icon-tabler-trash"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>
                Удаленные
              </a>
            </li>
          </ul>
        </div>
        <div class="card-header align-items-center" v-if="comments.hasItems()">
          <div class="col">
            <h3 class="card-title">
              <input class="form-check-input me-1" type="checkbox" v-model="comments.selectAll" @change="comments.toggleAll()">
              <span class="comment-select-all ms-2" @click="comments.toggleAllLabel()">выбрать всё</span>
            </h3>
          </div>
          <div class="col-auto">
            <button title="Одобрить выбранные" class="btn btn-green btn-responsive-sm btn-icon" @click="comments.events.onApproveSelect()" :class="{'disabled': comments.approveSelect.isDisabledBtn()}">
              <template v-if="comments.loading.loaders.approveSelectStatus.isProcess()">
                <span class="spinner-border spinner-border-sm" role="status"></span>
              </template>
              <template v-else>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon dropdown-item-icon icon-tabler icons-tabler-outline icon-tabler-circle-check">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                  <path d="M9 12l2 2l4 -4" />
                </svg>
              </template>
            </button>
            <button title="Отклонить выбранные" class="btn btn-red btn-responsive-sm btn-icon ms-2" @click="comments.events.onRejectSelect()" :class="{'disabled': comments.rejectSelect.isDisabledBtn()}">
              <template v-if="comments.loading.loaders.rejectSelectStatus.isProcess()">
                <span class="spinner-border spinner-border-sm" role="status"></span>
              </template>
              <template v-else>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon dropdown-item-icon icon-tabler icons-tabler-outline icon-tabler-circle-x"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M10 10l4 4m0 -4l-4 4" /></svg>
              </template>
            </button>
          </div>
        </div>
        <div class="card-table table-responsive">
          <div class="comment-moderation-empty" v-if="!comments.hasItems() && !comments.loading.loaders.baseLoadStatus.isProcess()">
            <span>Комментариев не найдено</span>
          </div>
          <table class="comment-moderation-table table table-vcenter table-hover" v-if="comments.hasItems()">
            <tbody>
            <!--table-danger-->
            <!--table-primary-->
            <!--table-light-->
            <tr class="table-light" v-for="comment in comments.items.value" :key="comments.element.getId(comment)">
              <td class="comment-moderation-select">
                <input class="form-check-input" type="checkbox" :checked="comments.isChecked(comments.element.getId(comment))" @change="comments.toggleItem(comments.element.getId(comment))">
              </td>
              <td class="comment-moderation-content" :class="{'comment-moderation-edit': comments.isCommentEdit(comments.element.getId(comment))}">
                <div class="list-group list-group-flush list-group-hoverable" :class="{'comment-moderation-parent-show': comments.isShowParent(comments.element.getId(comment))}">
                  <div class="comment-moderation-parent">
                    <div class="align-items-center">
                        <span class="comment-moderation-user">
                          <template v-if="comments.element.hasParent(comment)">
                            <div class="col-auto comment-moderation-avatar">
                              <span class="avatar" :style="{ backgroundImage: 'url('+ comments.element.getParentAvatar(comment, 60, 60) +')'}"></span>
                            </div>
                            <div class="col ms-2">
                              <span class="text-reset d-block comment-moderation-author">{{ comments.element.getParentUserName(comment) }}</span>
                              <div class="d-block text-secondary">{{ comments.element.getParentText(comment) }}</div>
                            </div>
                          </template>
                        </span>
                      <div class="list-group list-group-flush list-group-hoverable">
                        <div class="comment-moderation-children">
                          <div class="align-items-center comment-moderation-children-item">
                            <div class="col-auto comment-moderation-avatar" @click="comments.toggleItem(comments.element.getId(comment))">
                              <span class="avatar" :style="{ backgroundImage: 'url('+ comments.element.getAvatar(comment, 60, 60) +')'}"></span>
                            </div>
                            <div class="col ms-2">
                              <span class="text-reset d-block comment-moderation-author">{{ comments.element.getUserName(comment) }}</span>
                              <div class="d-block comment-moderation-edit-content">
                                <textarea :key="comments.element.getId(comment)" :ref="el => comments.bindTextarea(comments.element.getId(comment), el)" class="w-100" v-model="comment['text']"></textarea>
                              </div>
                              <div class="d-block comment-moderation-show-content" :class="{'open': comments.isShowFullText(comments.element.getId(comment))}">
                                <div class="comment-moderation-images mt-1" v-if="comments.element.hasImages(comment)">
                                  <Lightbox :images="{thumb: comments.element.getImages(comment, 70), origin: comments.element.getImages(comment)}"></Lightbox>
                                </div>
                                <span @click="comments.events.onText(comments.element.getId(comment))">{{ comments.element.getText(comment) }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="align-items-center mt-1 comment-moderation-edit-btns">
                            <div class="col text-end">
                              <button title="Отменить" class="btn btn-red btn-responsive-sm ms-2 btn-icon" @click="comments.events.closeEdit(comments.element.getId(comment))">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-back">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                  <path d="M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1" />
                                </svg>
                              </button>
                              <button title="Сохранить" class="btn btn-primary btn-responsive-sm ms-2" :class="{'disabled': comments.loading.loaders.saveLoadStatus.isProcess(comments.element.getId(comment))}" @click="comments.events.onEditApi(comments.element.getId(comment))">
                                <span class="spinner-border spinner-border-sm me-2" role="status" v-if="comments.loading.loaders.saveLoadStatus.isProcess(comments.element.getId(comment))"></span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-device-floppy">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                  <path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2" />
                                  <path d="M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                                  <path d="M14 4l0 4l-6 0l0 -4" />
                                </svg>
                                <span class="btn-responsive-text">Сохранить</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td class="comment-moderation-moderation1">
                <button title="Перейти в пост" class="btn btn-responsive-sm btn-icon ms-2" @click="comments.events.siteGoSourceLink(comment)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-link">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M9 15l6 -6" />
                    <path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" />
                    <path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" />
                  </svg>
                </button>
                <template v-if="comments.element.hasParent(comment)">
                  <button title="Посмотреть родительский комментарий" class="btn btn-responsive-sm btn-icon ms-2" @click="comments.events.onShowParent(comments.element.getId(comment))">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-list-tree">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M9 6h11" />
                      <path d="M12 12h8" />
                      <path d="M15 18h5" />
                      <path d="M5 6v.01" />
                      <path d="M8 12v.01" />
                      <path d="M11 18v.01" />
                    </svg>
                  </button>
                </template>
                <button title="Редактировать" class="btn btn-responsive-sm btn-icon ms-2" @click="comments.events.onEdit(comments.element.getId(comment))">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-edit">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                    <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                    <path d="M16 5l3 3" />
                  </svg>
                </button>
                <span
                    data-bs-toggle="modal"
                    data-type="update"
                    data-bs-target="#modal-comment_moderation-bans"
                    :data-object='banInfoBuildData(
                      comments.element.getUserId(comment),
                      comments.element.getUserName(comment)
                     )'
                >
                  <button title="Забанить" class="btn btn-responsive-sm btn-icon ms-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-hand-stop">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M8 13v-7.5a1.5 1.5 0 0 1 3 0v6.5" />
                    <path d="M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5" />
                    <path d="M14 5.5a1.5 1.5 0 0 1 3 0v6.5" />
                    <path d="M17 7.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47" />
                    </svg>
                  </button>
                </span>
              </td>
              <td class="comment-moderation-info">
                <div class="dropdown-menu dropdown-menu-demo">
                    <span class="dropdown-item">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon dropdown-item-icon icon-tabler icons-tabler-outline icon-tabler-calendar-month">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
                        <path d="M16 3v4" />
                        <path d="M8 3v4" />
                        <path d="M4 11h16" />
                        <path d="M7 14h.013" />
                        <path d="M10.01 14h.005" />
                        <path d="M13.01 14h.005" />
                        <path d="M16.015 14h.005" />
                        <path d="M13.015 17h.005" />
                        <path d="M7.01 17h.005" />
                        <path d="M10.01 17h.005" />
                      </svg>
                      {{ comments.element.getCreated(comment) }}
                    </span>
                  <span class="dropdown-item" v-if="comments.element.getIsModerate(comment) || comments.element.getIsReject(comment)">
                      <template v-if="comments.element.getIsModerate(comment)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2 icon-approve"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M9 12l2 2l4 -4" /></svg>
                      </template>
                      <template v-if="comments.element.getIsReject(comment)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2 icon-reject"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M10 10l4 4m0 -4l-4 4" /></svg>
                      </template>
                      <span class="avatar avatar-xs rounded me-2" :style="{ backgroundImage: 'url('+ comments.element.getModeratorAvatar(comment, 60, 60) +')'}"></span>
                      {{ comments.element.getModeratorUserName(comment) }}
                    </span>
                </div>
              </td>
              <td class="text-end comment-moderation-moderation2">
                <button title="Одобрить" class="btn btn-green btn-responsive-sm btn-icon" @click="comments.events.onApproveApi(comments.element.getId(comment))" :class="{'disabled': comments.approve.isDisabledBtn(comments.element.getId(comment))}">
                  <template v-if="comments.loading.loaders.approveLoadStatus.isProcess(comments.element.getId(comment))">
                    <span class="spinner-border spinner-border-sm" role="status"></span>
                  </template>
                  <template v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-circle-check"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M9 12l2 2l4 -4" /></svg>
                  </template>
                </button>
                <button title="Отклонить" class="btn btn-red btn-responsive-sm btn-icon ms-2" @click="comments.events.onRejectApi(comments.element.getId(comment))" :class="{'disabled': comments.reject.isDisabledBtn(comments.element.getId(comment))}">
                  <template v-if="comments.loading.loaders.rejectLoadStatus.isProcess(comments.element.getId(comment))">
                    <span class="spinner-border spinner-border-sm" role="status"></span>
                  </template>
                  <template v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon dropdown-item-icon icon-tabler icons-tabler-outline icon-tabler-circle-x"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M10 10l4 4m0 -4l-4 4" /></svg>
                  </template>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="comment-moderation-loading" v-if="comments.loading.loaders.baseLoadStatus.isProcess()">
            <div class="spinner-border"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="d-flex justify-content-center">
          <span class="btn btn-primary" @click.prevent="comments.events.onNextPage()" :class="{'disabled': !comments.isShowNextPage()}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-loader"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 6l0 -3" /><path d="M16.25 7.75l2.15 -2.15" /><path d="M18 12l3 0" /><path d="M16.25 16.25l2.15 2.15" /><path d="M12 18l0 3" /><path d="M7.75 16.25l-2.15 2.15" /><path d="M6 12l-3 0" /><path d="M7.75 7.75l-2.15 -2.15" /></svg>
            Загрузить ещё
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="mb-3">
        <div class="card-table table-responsive">
          <div class="comment-moderation-loading" v-if="comments.isLoadComponent()">
            <div class="spinner-border"></div>
          </div>
          <div class="comment-moderation-error" v-if="error.hasError()">
            <span>{{ error.getError() }} [comment_moderation]</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Teleport to="body">
    <BansModal />
  </Teleport>
</template>

<script>
import { defineComponent } from 'vue'
import Lightbox from "@/components/lightbox/Lightbox"
import BansModal from "./components/bans_modal/Index"
import { useCommentModeration } from './CommentModeration.js'

export default defineComponent({
  name: 'SiteCommentModeration',
  components: {
    Lightbox,
    BansModal,
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const {
      error,
      comments,
      isShowComponent,
      categoryList: {
        allCategory,
        approvedCategory,
        newCategory,
        rejectedCategory,
        removedCategory,
      },
      countCategories,
      params,
      banInfoBuildData,
    } = useCommentModeration(props)

    return {
      error,
      comments,
      isShowComponent,
      categoryList: {
        allCategory,
        approvedCategory,
        newCategory,
        rejectedCategory,
        removedCategory,
      },
      countCategories,
      params,
      banInfoBuildData,
    }
  }
})
</script>

<style scoped src="./css/style.css"></style>
